module.exports = __webpack_public_path__ + "static/media/ipad-left-img.bb77f304.jpg";